module.exports = __webpack_public_path__ + "img/9-3_Latent_Linear.e2640986.png";